<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Informations générales</h4>
            <router-link to="/liste-offres" class=" btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour</router-link>
          </div>
          <table class="table">
            <tbody>
              <tr v-if="offre?.categorieOffre">
                <td>Catégorie d'offre: </td>
                <td>{{ offre?.categorieOffre?.libelle }}</td>
              </tr>
              <tr v-if="offre?.titre">
                <td>Titre :</td>
                <td>{{ offre?.titre }}</td>
              </tr>
              <tr v-if="offre?.description">
                <td>Description :</td>
                <td>{{ offre?.description }}</td>
              </tr>
              <tr v-if="offre?.salaire">
                <td>Salaire :</td>
                <td>{{ offre?.salaire }}</td>
              </tr>
              <tr v-if="offre?.datePublication">
                <td>Date de publication :</td>
                <td>{{format_Date( offre?.datePublication) }}</td>
              </tr>
              <tr v-if="offre?.dateExpiration">
                <td>Date d'expiration:</td>
                <td>{{ format_Date(offre?.dateExpiration) }}</td>
              </tr>
              <tr v-if="offre?.commune">
                <td>Commune :</td>
                <td>{{ offre?.commune?.libelle }}</td>
              </tr>
              <tr v-if="offre?.activite">
                <td>Activité :</td>
                <td>{{ offre?.activite?.libelle }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { Offre } from "@/models/Offre";
import { error, format_Date, showModal } from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewOffre",
  setup: () => {
    const route = useRoute();
    const offre = ref<Offre | null>(null);

    function getOffre(id: string) {
      return ApiService.get("/offres", id)
        .then(({ data }) => {
          offre.value = data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }
    onMounted(() => {
      const id = route.params.id as string;
      getOffre(id);
    });

    return {
      offre,
      getOffre,
      format_Date,
    };
  },
});
</script>
